(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CompendiumSpecialPrice', CompendiumSpecialPrice);

    CompendiumSpecialPrice.$inject = ['$resource'];

    function CompendiumSpecialPrice ($resource) {
        var resourceUrl =  'api/compendium-special-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
